import { api, unwrapData } from '../../../app/store/api';

export const userInfoApi = api.injectEndpoints({
    endpoints: (build) => ({
        userSessions: build.query<any, { page?: number; perPage?: number }>({
            transformResponse: unwrapData,
            query: ({ page, perPage = 15 }) => ({
                url: 'user/me/sessions',
                method: 'GET',
                params: {
                    ...(page && { page }),
                    ...(perPage && { per_page: perPage }),
                },
            }),
            providesTags: ['Session'],
        }),
        revokeSession: build.mutation<any, { token_id: string }>({
            transformResponse: unwrapData,
            query: (body) => ({
                url: 'user/me/revoke-session',
                method: 'POST',
                body,
            }),
            invalidatesTags: (result) => (result ? [{ type: 'Session' }] : []),
        }),
    }),
});

export const { useUserSessionsQuery, useRevokeSessionMutation } = userInfoApi;
